import styled from '@emotion/styled';
import { desaturate, lighten } from 'polished';
import {
  BodyBoldText,
  SecondaryText,
  TertiaryText,
} from '@silvertours/front-shared';
import { DeleteButtonInteractiveText } from './DeleteButtonContent';

const SearchHistoryHeadline = styled(TertiaryText)`
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

const SearchHistoryListItem = styled(BodyBoldText)`
  display: block;
`;

const SearchHistoryDate = styled(SecondaryText)`
  display: block;
`;

const DeleteButtonContent = styled(DeleteButtonInteractiveText)`
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  display: inline-block;
  text-underline-offset: 0.125rem;

  &:hover {
    text-decoration-line: underline;
  }
`;

type SearchHistoryWrapperProps = {
  hidden: boolean;
};

const SearchHistoryWrapper = styled.div<SearchHistoryWrapperProps>`
  display: ${({ hidden }) => hidden && 'none'};
  border-color: ${({ theme }) =>
    lighten(0.065, desaturate(0.25, theme.color.highlightPrimary!))};
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  position: absolute;
  top: 3.75rem;
  left: 0;
  z-index: 50;
  box-sizing: border-box;
  max-height: 25rem;
  width: 100%;
  overflow-y: auto;
  border-radius: 0.5rem;
  border-width: 0.125rem;
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 10%),
    0 2px 4px -2px rgb(0 0 0 / 10%);
  background-color: ${({ theme }) => theme.color.white};
`;

export {
  DeleteButtonContent,
  SearchHistoryHeadline,
  SearchHistoryListItem,
  SearchHistoryDate,
  SearchHistoryWrapper,
};
